/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSellGift.vue?vue&type=template&id=0169a834&scoped=true"
import script from "./popSellGift.vue?vue&type=script&lang=js"
export * from "./popSellGift.vue?vue&type=script&lang=js"
import style0 from "./popSellGift.vue?vue&type=style&index=0&id=0169a834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0169a834",
  null
  
)

export default component.exports